export default __webpack_public_path__ + "static/media/sachs.ca31f118.jpg";